/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MethodInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class MethodApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Methods');
  }

  public getMethods(params: HttpParams): Observable<{ count: number; results: MethodInterface[] }> {
    return this.get('search', params);
  }

  public createMethod(method: MethodInterface): Observable<MethodInterface> {
    return this.post(null, null, method);
  }

  public updateMethod(params: HttpParams, method: MethodInterface): Observable<MethodInterface> {
    return this.put(null, params, method);
  }

  public deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<void>(path).pipe(map(() => true));
  }
}
